import { Alert, IIconProps, IPressableProps, Pressable } from 'native-base';
import React, { ReactNode } from 'react';

import CPPopover, { CPPopoverProps } from 'app/components/CPPopover';
import { useI18n } from 'app/providers/I18nProvider';

export type InfoPopoverProps = Pick<CPPopoverProps, 'onOpen'> & {
  children: ReactNode;
  _icon?: IIconProps;
  _pressable?: IPressableProps;
};

export default function InfoPopover({ children, _icon, _pressable, ...props }: InfoPopoverProps) {
  const { t } = useI18n();
  return (
    <CPPopover
      {...props}
      trigger={(triggerProps) => (
        <Pressable
          m="-4"
          p="4"
          {..._pressable}
          {...triggerProps}
          accessibilityLabel={`${t<string>('gen_open')} Info Popover`}
        >
          <Alert.Icon color="brand.secondary" {..._icon} />
        </Pressable>
      )}
    >
      {children}
    </CPPopover>
  );
}
